import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import LngDetector from 'i18next-browser-languagedetector';
const URL_STATIC_RESOURCES = process.env.REACT_APP_STATIC_RESOURCES_URL;

const detectionOptions = {
  order: [
    'navigator',
    'localStorage',
    'subdomain',
    'queryString',
    'htmlTag',
    'path',
    'cookie'
  ],
  lookupFromPathIndex: 0
};

i18next
  .use(Backend)
  .use(LngDetector)
  .use(initReactI18next)
  .init({
    load: 'languageOnly',
    ns: ['common', 'app', 's3common', 's3app'],
    detection: detectionOptions,
    debug: false,
    fallbackLng: ['en'],
    fallbackNS: ['s3common', 's3app', 'common', 'app'],
    defaultNS: 's3common',
    backend: {
      loadPath: function (lngs, namespaces) {
        if (namespaces.every(ns => ['app', 'common'].includes(ns))) {
          return '/locales/{{lng}}/{{ns}}.json';
        }
        return `${URL_STATIC_RESOURCES}/gouze/locales/{{lng}}/{{ns}}.json`;
      },
      crossDomain: true
    }
  });

export default i18next;
